import { HI_DATA_USER_ERROR_MESSAGE, LinkConfiguration, TREBEK_QUERY_ERROR_MESSAGE, WidgetData } from '@ddv/models';

interface Links {
    links?: { [key: string]: LinkConfiguration };
}

export enum TrebekQueryResultStatus {
    NOT_READY = 'NOT_READY',
    FAILED = 'FAILED',
    DONE = 'DONE',
}

export interface TrebekQueryResponseRow extends Links {
    selectedColumnData: WidgetData;
}

interface BaseAsyncQueryResponse {
    queryId: string;
    status: TrebekQueryResultStatus;
    created: string;
    updated?: string;
}

interface QueryNotReadyResponse extends BaseAsyncQueryResponse {
    status: TrebekQueryResultStatus.NOT_READY;
}

export interface QueryFailedResponse extends BaseAsyncQueryResponse {
    status: TrebekQueryResultStatus.FAILED;
    error: string;
}

export interface QueryDoneResponse extends BaseAsyncQueryResponse {
    status: TrebekQueryResultStatus.DONE;
    url: string;
}

export interface QueryResultResponse {
    data: TrebekQueryResponseRow[];
}

export interface ChoiceListResponse {
    choices: { text: string, value: boolean | string | number }[];
    isPartial: boolean;
}

export interface MappedChoiceList {
    id: string;
    choiceListResponse: ChoiceListResponse;
}

export type TrebekQueryResponse = QueryNotReadyResponse | QueryFailedResponse | QueryDoneResponse;

export type PublicApiResponseRow = (WidgetData & Links);

export type DatedPublicApiResponseRow = (PublicApiResponseRow & { date?: string });

export abstract class TrebekError extends Error {
    public readonly timestamp = new Date().toISOString();

    protected constructor(
        public readonly rootCause: { errorCode?: string, errorMessage?: string } | string | undefined,
        message: string,
    ) {
        super(message);
    }
}

export class GenericTrebekError extends TrebekError {
    constructor(rootCause: { errorCode?: string, errorMessage?: string } | string | undefined) {
        super(rootCause, TREBEK_QUERY_ERROR_MESSAGE);
    }
}

export class NotEntitledToHedgeInvestorDataError extends TrebekError {
    constructor(rootCause: { errorCode?: string, errorMessage?: string } | string | undefined) {
        super(rootCause, HI_DATA_USER_ERROR_MESSAGE);
    }
}

export interface PublicAPIQueryResponse {
    data: PublicApiResponseRow[];
    queryId?: string;
}

export function isQueryNotReady(value: TrebekQueryResponse | null): value is QueryNotReadyResponse {
    return !!value && value.status === TrebekQueryResultStatus.NOT_READY;
}

export function isQueryFailed(value: TrebekQueryResponse | null): value is QueryFailedResponse {
    return !!value && value.status === TrebekQueryResultStatus.FAILED;
}
